/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { AxiosHttpRequest } from './core/AxiosHttpRequest';
import { AccountBookPendingTransactionService } from './services/AccountBookPendingTransactionService';
import { AdminService } from './services/AdminService';
import { AgreementsControllerService } from './services/AgreementsControllerService';
import { BatteryService } from './services/BatteryService';
import { BrakePadService } from './services/BrakePadService';
import { CacheControllerService } from './services/CacheControllerService';
import { CcsReportControllerService } from './services/CcsReportControllerService';
import { ConsentControllerService } from './services/ConsentControllerService';
import { CpoService } from './services/CpoService';
import { CryptoControllerService } from './services/CryptoControllerService';
import { DemeritEducationControllerService } from './services/DemeritEducationControllerService';
import { DriveHistoryService } from './services/DriveHistoryService';
import { DriveHistoryExcelService } from './services/DriveHistoryExcelService';
import { EcoMileageControllerService } from './services/EcoMileageControllerService';
import { EcoMileageExternalControllerService } from './services/EcoMileageExternalControllerService';
import { EngineControllerService } from './services/EngineControllerService';
import { EvBatteryAgreementTestControllerService } from './services/EvBatteryAgreementTestControllerService';
import { EvBatteryControllerService } from './services/EvBatteryControllerService';
import { EvBatteryManagementControllerService } from './services/EvBatteryManagementControllerService';
import { FinancialManagementControllerService } from './services/FinancialManagementControllerService';
import { FinancialTokenManagementControllerService } from './services/FinancialTokenManagementControllerService';
import { FuelService } from './services/FuelService';
import { HighwayUnpaidService } from './services/HighwayUnpaidService';
import { JwtControllerService } from './services/JwtControllerService';
import { LicenseRenewalControllerService } from './services/LicenseRenewalControllerService';
import { MaintenanceNotificationControllerService } from './services/MaintenanceNotificationControllerService';
import { MaintenanceRecordControllerService } from './services/MaintenanceRecordControllerService';
import { MaintenancesScheduleControllerService } from './services/MaintenancesScheduleControllerService';
import { MaintenancesSestControllerService } from './services/MaintenancesSestControllerService';
import { NotificationControllerService } from './services/NotificationControllerService';
import { OdometerService } from './services/OdometerService';
import { PublicServiceService } from './services/PublicServiceService';
import { PublicServiceInspectionService } from './services/PublicServiceInspectionService';
import { PublicServiceInspectionFromKotsaService } from './services/PublicServiceInspectionFromKotsaService';
import { SalesControllerService } from './services/SalesControllerService';
import { SpecialInsuranceContractControllerService } from './services/SpecialInsuranceContractControllerService';
import { TermsControllerService } from './services/TermsControllerService';
import { TireService } from './services/TireService';
import { TripTagsService } from './services/TripTagsService';
import { UbiAppControllerService } from './services/UbiAppControllerService';
import { UbiCcsControllerService } from './services/UbiCcsControllerService';
import { UbiControllerService } from './services/UbiControllerService';
import { UbiForMyAppControllerService } from './services/UbiForMyAppControllerService';
import { UbiThirdPartyAgreementsControllerService } from './services/UbiThirdPartyAgreementsControllerService';
import { UbiThirdPartyTermsControllerService } from './services/UbiThirdPartyTermsControllerService';
import { UserService } from './services/UserService';
import { VehicleService } from './services/VehicleService';
import { VehicleSettingControllerService } from './services/VehicleSettingControllerService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class DiApi {
  public readonly accountBookPendingTransaction: AccountBookPendingTransactionService;
  public readonly admin: AdminService;
  public readonly agreementsController: AgreementsControllerService;
  public readonly battery: BatteryService;
  public readonly brakePad: BrakePadService;
  public readonly cacheController: CacheControllerService;
  public readonly ccsReportController: CcsReportControllerService;
  public readonly consentController: ConsentControllerService;
  public readonly cpo: CpoService;
  public readonly cryptoController: CryptoControllerService;
  public readonly demeritEducationController: DemeritEducationControllerService;
  public readonly driveHistory: DriveHistoryService;
  public readonly driveHistoryExcel: DriveHistoryExcelService;
  public readonly ecoMileageController: EcoMileageControllerService;
  public readonly ecoMileageExternalController: EcoMileageExternalControllerService;
  public readonly engineController: EngineControllerService;
  public readonly evBatteryAgreementTestController: EvBatteryAgreementTestControllerService;
  public readonly evBatteryController: EvBatteryControllerService;
  public readonly evBatteryManagementController: EvBatteryManagementControllerService;
  public readonly financialManagementController: FinancialManagementControllerService;
  public readonly financialTokenManagementController: FinancialTokenManagementControllerService;
  public readonly fuel: FuelService;
  public readonly highwayUnpaid: HighwayUnpaidService;
  public readonly jwtController: JwtControllerService;
  public readonly licenseRenewalController: LicenseRenewalControllerService;
  public readonly maintenanceNotificationController: MaintenanceNotificationControllerService;
  public readonly maintenanceRecordController: MaintenanceRecordControllerService;
  public readonly maintenancesScheduleController: MaintenancesScheduleControllerService;
  public readonly maintenancesSestController: MaintenancesSestControllerService;
  public readonly notificationController: NotificationControllerService;
  public readonly odometer: OdometerService;
  public readonly publicService: PublicServiceService;
  public readonly publicServiceInspection: PublicServiceInspectionService;
  public readonly publicServiceInspectionFromKotsa: PublicServiceInspectionFromKotsaService;
  public readonly salesController: SalesControllerService;
  public readonly specialInsuranceContractController: SpecialInsuranceContractControllerService;
  public readonly termsController: TermsControllerService;
  public readonly tire: TireService;
  public readonly tripTags: TripTagsService;
  public readonly ubiAppController: UbiAppControllerService;
  public readonly ubiCcsController: UbiCcsControllerService;
  public readonly ubiController: UbiControllerService;
  public readonly ubiForMyAppController: UbiForMyAppControllerService;
  public readonly ubiThirdPartyAgreementsController: UbiThirdPartyAgreementsControllerService;
  public readonly ubiThirdPartyTermsController: UbiThirdPartyTermsControllerService;
  public readonly user: UserService;
  public readonly vehicle: VehicleService;
  public readonly vehicleSettingController: VehicleSettingControllerService;
  public readonly request: BaseHttpRequest;
  constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
    this.request = new HttpRequest({
      BASE: config?.BASE ?? 'https://stg-di-api.kia-corp.io',
      VERSION: config?.VERSION ?? '0.0.1',
      WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
      CREDENTIALS: config?.CREDENTIALS ?? 'include',
      TOKEN: config?.TOKEN,
      USERNAME: config?.USERNAME,
      PASSWORD: config?.PASSWORD,
      HEADERS: config?.HEADERS,
      ENCODE_PATH: config?.ENCODE_PATH,
    });
    this.accountBookPendingTransaction = new AccountBookPendingTransactionService(this.request);
    this.admin = new AdminService(this.request);
    this.agreementsController = new AgreementsControllerService(this.request);
    this.battery = new BatteryService(this.request);
    this.brakePad = new BrakePadService(this.request);
    this.cacheController = new CacheControllerService(this.request);
    this.ccsReportController = new CcsReportControllerService(this.request);
    this.consentController = new ConsentControllerService(this.request);
    this.cpo = new CpoService(this.request);
    this.cryptoController = new CryptoControllerService(this.request);
    this.demeritEducationController = new DemeritEducationControllerService(this.request);
    this.driveHistory = new DriveHistoryService(this.request);
    this.driveHistoryExcel = new DriveHistoryExcelService(this.request);
    this.ecoMileageController = new EcoMileageControllerService(this.request);
    this.ecoMileageExternalController = new EcoMileageExternalControllerService(this.request);
    this.engineController = new EngineControllerService(this.request);
    this.evBatteryAgreementTestController = new EvBatteryAgreementTestControllerService(this.request);
    this.evBatteryController = new EvBatteryControllerService(this.request);
    this.evBatteryManagementController = new EvBatteryManagementControllerService(this.request);
    this.financialManagementController = new FinancialManagementControllerService(this.request);
    this.financialTokenManagementController = new FinancialTokenManagementControllerService(this.request);
    this.fuel = new FuelService(this.request);
    this.highwayUnpaid = new HighwayUnpaidService(this.request);
    this.jwtController = new JwtControllerService(this.request);
    this.licenseRenewalController = new LicenseRenewalControllerService(this.request);
    this.maintenanceNotificationController = new MaintenanceNotificationControllerService(this.request);
    this.maintenanceRecordController = new MaintenanceRecordControllerService(this.request);
    this.maintenancesScheduleController = new MaintenancesScheduleControllerService(this.request);
    this.maintenancesSestController = new MaintenancesSestControllerService(this.request);
    this.notificationController = new NotificationControllerService(this.request);
    this.odometer = new OdometerService(this.request);
    this.publicService = new PublicServiceService(this.request);
    this.publicServiceInspection = new PublicServiceInspectionService(this.request);
    this.publicServiceInspectionFromKotsa = new PublicServiceInspectionFromKotsaService(this.request);
    this.salesController = new SalesControllerService(this.request);
    this.specialInsuranceContractController = new SpecialInsuranceContractControllerService(this.request);
    this.termsController = new TermsControllerService(this.request);
    this.tire = new TireService(this.request);
    this.tripTags = new TripTagsService(this.request);
    this.ubiAppController = new UbiAppControllerService(this.request);
    this.ubiCcsController = new UbiCcsControllerService(this.request);
    this.ubiController = new UbiControllerService(this.request);
    this.ubiForMyAppController = new UbiForMyAppControllerService(this.request);
    this.ubiThirdPartyAgreementsController = new UbiThirdPartyAgreementsControllerService(this.request);
    this.ubiThirdPartyTermsController = new UbiThirdPartyTermsControllerService(this.request);
    this.user = new UserService(this.request);
    this.vehicle = new VehicleService(this.request);
    this.vehicleSettingController = new VehicleSettingControllerService(this.request);
  }
}

